import { render, staticRenderFns } from "./BaseTagsSelect.vue?vue&type=template&id=75327e0c&"
import script from "./BaseTagsSelect.vue?vue&type=script&lang=js&"
export * from "./BaseTagsSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports